import { AxiosClient } from "@/app/shared/services";
import eventService from "./services/eventService";

const state = {
    list: {
        events: [],
        isLoading: false,
    },
    pagination: {
        isLoading: false,
        data: {},
        items: [],
        selectedItem: {},
        showModal: false,
    },
};

const getters = {
    EVENT_LIST: (state) => state.list.events,
    EVENT_LIST_LOADING: (state) => state.list.isLoading,
    EVENT_PAGINATION_DATA: (state) => state.pagination.data,
    EVENT_PAGINATION_ITEMS: (state) => state.pagination.items,
    EVENT_PAGINATION_LOADING: (state) => state.pagination.isLoading,
    EVENT_INFO_ITEM: (state) => state.pagination.selectedItem,
    EVENT_INFO_MODAL_OPENED: (state) => state.pagination.showModal,
};

const mutations = {
    SET_EVENT_LIST: (state, list) => {
        state.list.events = list;
    },
    SET_EVENTS_LIST_LOADING: (state, isLoading) => {
        state.list.isLoading = isLoading;
    },
    SET_EVENT_PAGINATION_LOADING: (state, isLoading) => {
        state.pagination.isLoading = isLoading;
    },
    SET_EVENT_PAGINATION_DATA: (state, data) => {
        state.pagination.data = data;
    },
    SET_EVENT_PAGINATION_ITEMS: (state, items) => {
        state.pagination.items = eventService.parseEvents(items);
    },
    SET_EVENT_INFO_ITEM: (state, item) => {
        state.pagination.selectedItem = item;
    },
    SET_EVENT_INFO_MODAL_OPENED: (state, isOpened) => {
        state.pagination.showModal = isOpened;
    },
};

const actions = {
    FETCH_EVENT_LIST: (context, params) => {
        context.commit("SET_EVENTS_LIST_LOADING", true);
        return new Promise((resolve, reject) => {
            AxiosClient.get("/events/list", { params })
                .then((response) => {
                    const events = eventService.parseEventList(response.data);
                    context.commit("SET_EVENT_LIST", events);
                    resolve(events);
                })
                .catch(() => reject())
                .finally(() => context.commit("SET_EVENTS_LIST_LOADING", false));
        });
    },

    EVENT_PAGINATION: (context, { pagination, filters }) => {
        context.commit("SET_EVENT_PAGINATION_LOADING", true);
        return new Promise((resolve, reject) => {
            const params = Object.assign({}, pagination, { filters: JSON.stringify(filters) });
            AxiosClient.get("/events/pagination", { params })
                .then((response) => {
                    context.commit("SET_EVENT_PAGINATION_DATA", response.data);
                    context.commit("SET_EVENT_PAGINATION_ITEMS", response.data.results);
                    resolve(response.data);
                })
                .catch(() => reject())
                .finally(() => context.commit("SET_EVENT_PAGINATION_LOADING", false));
        });
    },

    SHOW_EVENT_DETAIL_MODAL: (context, event) => {
        context.commit("SET_EVENT_INFO_ITEM", event);
        context.commit("SET_EVENT_INFO_MODAL_OPENED", true);
    },

    CLOSE_EVENT_DETAIL_MODAL: (context) => {
        context.commit("SET_EVENT_INFO_ITEM", {});
        context.commit("SET_EVENT_INFO_MODAL_OPENED", false);
    },
};

export default { state, getters, mutations, actions };
